// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__15Klt","rootCenter":"LoadMoreObserver_rootCenter__oL9pI","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__rO-A2"};